<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="固定资产编号" prop="assetNumber">
                        <el-input clearable v-model="dataForm.assetNumber"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="名称" prop="name">
                        <el-input clearable v-model="dataForm.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="型号规格" prop="specification">
                        <el-input clearable v-model="dataForm.specification"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="类别" prop="assetTypeId">
                        <el-select clearable filterable v-model="dataForm.assetTypeId" placeholder="类别">
                            <el-option v-for="item in types" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="部门" prop="deptId">
                        <el-select clearable filterable v-model="dataForm.deptId" placeholder="部门">
                            <el-option v-for="item in depts" :key="item.bmid" :label="item.bmmc"
                                       :value="item.bmid"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="使用人">
                        <el-input clearable v-model="dataForm.syrxm"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="存放地点" prop="stroagePostion">
                        <el-input clearable v-model="dataForm.stroagePostion"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="使用状况" prop="useState">
                        <el-input clearable v-model="dataForm.useState"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="使用年限(年)" prop="allUseTimeYear">
                        <el-input clearable v-model="dataForm.allUseTimeYear"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="使用年限(月)" prop="allUseTimeMonth">
                        <el-input clearable v-model="dataForm.allUseTimeMonth"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="折旧方法" prop="method">
                        <el-select v-model="dataForm.method" clearable placeholder="折旧方法">
                            <el-option :key="0" :label="'平均年限法'" :value="0"></el-option>
                            <el-option :key="1" :label="'直接报废法'" :value="1"></el-option>
                            <el-option :key="2" :label="'一次性折旧法'" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="登记时间" prop="time">
                        <el-date-picker
                                v-model="dataForm.time"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开始使用日期" prop="beginUseTime">
                        <el-date-picker
                                v-model="dataForm.beginUseTime"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="可抵扣税额" prop="kdkse">
                        <el-input clearable v-model="dataForm.kdkse"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="币种" prop="currency">
                        <el-select v-model="dataForm.currency" clearable placeholder="币种">
                            <el-option :key="0" :label="'人民币'" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="原值(元)" prop="yz">
                        <el-input clearable @change="getCanZhi" v-model="dataForm.yz"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="this.dataForm.method === 0">
                <el-col :span="12">
                    <el-form-item label="净残值率(%)" prop="jczl">
                        <el-input @change="getCanZhi" clearable v-model="dataForm.jczl"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="净残值" prop="jcz">
                        <!-- <el-input clearable :disabled="true" v-model="dataForm.jcz"></el-input> -->
                        <el-input clearable v-model="dataForm.jcz"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="累计折旧(元)" prop="ljzj">
                        <el-input clearable v-model="dataForm.ljzj"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="净值(元)" prop="jz">
                        <el-input clearable v-model="dataForm.jz"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="月折旧率(%)" prop="yzjl">
                        <el-input clearable v-model="dataForm.yzjl"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="月折旧额(元)" prop="yzje">
                        <el-input clearable v-model="dataForm.yzje"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="对应折旧科目" prop="dyjzkm">
                        <el-input clearable v-model="dataForm.dyjzkm"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="项目" prop="project">
                        <el-input clearable v-model="dataForm.project"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="增加方式" prop="addType">
                        <el-input clearable v-model="dataForm.addType"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>


            <!-- <el-col :span="12">
               <el-form-item label="已计提月份" prop="hasUseMonth">
                             <el-input clearable :disabled="true" v-model="dataForm.hasUseMonth" ></el-input>
               </el-form-item>
             </el-col>-->
            <!--     <el-col :span="12">
                   <el-form-item label="累计折旧" prop="ljzj">
                     <el-input clearable v-model="dataForm.ljzj" ></el-input>
                   </el-form-item>
                 </el-col>-->
            <!--   <el-col :span="12">
                 <el-form-item label="净值" prop="jz">
                   <el-input clearable v-model="dataForm.jz" ></el-input>
                 </el-form-item>
               </el-col>-->
            <!--<el-row>

              <el-col :span="12">
                <el-form-item label="月折旧率" prop="yzjl">
                  <el-input clearable v-model="dataForm.yzjl" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="月折旧额" prop="yzje">
                  <el-input clearable v-model="dataForm.yzje" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>-->
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data() {
            const validateNumber = (rule, value, callback) => {
                if (value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        callback()
                    }
                } else callback()
            }
            const validateallUseTimeMonth = (rule, value, callback) => {
                if (value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        // var number = Number.parseFloat(value);
                        // if (number % 1 !== 0) callback(new Error('请输入整数'))
                        // if (number > 12) callback(new Error('月份不可大于12'))
                        // else callback()
                        callback()
                    }
                } else {
                    if (this.dataForm.allUseTimeYear) callback();
                    else callback(new Error('请输入年份或月份'))
                }
            }
            const validateallUseTimeYear = (rule, value, callback) => {
                if (value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        var number = Number.parseFloat(value);
                        if (number % 1 !== 0) callback(new Error('请输入整数'))
                        else callback()
                    }
                } else {
                    if (this.dataForm.allUseTimeMonth) callback();
                    else callback(new Error('请输入年份或月份'))
                }
            }
            const validateJczl = (rule, value, callback) => {
                if (value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        var number = Number.parseFloat(value);
                        if (number > 100) callback(new Error('不能超过100%'))
                        else callback()
                    }
                } else callback()
            }
            return {
                //表单验证规则
                rules: {
                    name: [{required: true, trigger: 'blur', message: '请输入名称'}],
                    time: [{required: true, trigger: 'blur', message: '请输入登记时间'}],
                    assetNumber: [{required: true, trigger: 'blur', message: '请输入固定资产编号'}],
                    assetTypeId: [{required: true, trigger: 'blur', message: '请选择类别'}],
                    allUseTimeYear: [{validator: validateallUseTimeYear, trigger: 'blur'}],
                    method: [{required: true, trigger: 'blur', message: '请选择折旧方法'}],
                    beginUseTime: [{required: true, trigger: 'blur', message: '请选择开始使用日期'}],
                    currency: [{required: true, trigger: 'blur', message: '请输入币种'}],
                    yz: [{required: true, trigger: 'blur', message: '请输入原值'},
                        {validator: validateNumber, trigger: 'blur'}],
                    jczl: [{required: true, trigger: 'blur', message: '请输入净残值率'},
                        {validator: validateJczl, trigger: 'blur'}],
                    kdkse: [{validator: validateNumber, trigger: 'blur'}],
                    allUseTimeMonth: [{validator: validateallUseTimeMonth, trigger: 'blur'}],
                    ljzj: [{validator: validateNumber, trigger: 'blur'}],
                    jz: [{validator: validateNumber, trigger: 'blur'}],
                    yzjl: [{validator: validateJczl, trigger: 'blur'}],
                    yzje: [{validator: validateNumber, trigger: 'blur'}]
                },
                visible: false,
                depts: [],
                types: [],
                dataForm: {
                    id: '',
                    name: '',
                    specification: '',
                    price: '',
                    num: '',
                    sum: '',
                    time: '',
                    assetNumber: '',
                    assetTypeId: '',
                    deptId: '',
                    addType: '',
                    stroagePostion: '',
                    useState: '',
                    allUseTimeYear: '',
                    method: '',
                    beginUseTime: '',
                    hasUseMonth: '',
                    currency: '',
                    yz: '',
                    jczl: '',
                    jcz: '',
                    jz: '',
                    dyjzkm: '',
                    project: '',
                    kdkse: '',
                    createUser: '',
                    updateUser: '',
                    updateTime: '',
                    allUseTimeMonth: '',
                    ljzj: '',
                    yzjl: '',
                    yzje: '',
                    syrxm: '',
                }
            }
        },
        methods: {
            init(id) {
                this.dataForm.jcz = ''
                this.dataForm.syrxm = ''
                this.dataForm.id = id
                this.visible = true
                this.$nextTick(() => {
                    this.getDepts();
                    this.getTypes();
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.$http({
                            url: '/bjba/asset/info/' + this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            this.dataForm = data.data
                            // this.dataForm.id = data.data.id
                            // this.dataForm.name = data.data.name
                            // this.dataForm.specification = data.data.specification
                            // this.dataForm.price = data.data.price
                            // this.dataForm.num = data.data.num
                            // this.dataForm.sum = data.data.sum
                            // this.dataForm.time = data.data.time
                            // this.dataForm.assetNumber = data.data.assetNumber
                            // this.dataForm.assetTypeId = data.data.assetTypeId
                            // this.dataForm.deptId = data.data.deptId
                            // this.dataForm.addType = data.data.addType
                            // this.dataForm.stroagePostion = data.data.stroagePostion
                            // this.dataForm.useState = data.data.useState
                            // this.dataForm.allUseTimeYear = data.data.allUseTimeYear
                            // this.dataForm.method = data.data.method
                            // this.dataForm.beginUseTime = data.data.beginUseTime
                            // this.dataForm.hasUseMonth = data.data.hasUseMonth
                            // this.dataForm.currency = data.data.currency
                            // this.dataForm.yz = data.data.yz
                            // this.dataForm.jczl = data.data.jczl
                            // this.dataForm.jcz = data.data.jcz
                            // this.dataForm.jz = data.data.jz
                            // this.dataForm.dyjzkm = data.data.dyjzkm
                            // this.dataForm.project = data.data.project
                            // this.dataForm.kdkse = data.data.kdkse
                            // this.dataForm.createUser = data.data.createUser
                            // this.dataForm.updateUser = data.data.updateUser
                            // this.dataForm.updateTime = data.data.updateTime
                            // this.dataForm.allUseTimeMonth = data.data.allUseTimeMonth
                            // this.dataForm.ljzj = data.data.ljzj
                            // this.dataForm.yzjl = data.data.yzjl
                            // this.dataForm.yzje = data.data.yzje

                        })
                    }
                })

            },
            getCanZhi() {
                // var yz = Number.parseFloat(this.dataForm.yz);
                // var jczl = Number.parseFloat(this.dataForm.jczl);
                // if (yz && jczl) {
                //     // var jcz = (yz * jczl * 0.01).toFixed(2) // 之前公式计算净残值
                //     var jcz = (yz * jczl).toFixed(2)
                //     this.dataForm.jcz = jcz
                // }

            },
            getDepts() {
                let that = this;
                this.$request.get('/bjba/kqtj/getMentForUser', {
                    params: {
                        userid: this.$store.getters.username
                    }

                }).then(res => {
                    that.depts = res.data
                })
            },
            getTypes() {
                let that = this;
                this.$request.get('/bjba/asset/type/queryAll').then(res => {
                    that.types = res.data.data
                })
            },
            // 表单提交
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: `/bjba/asset/save`,
                            method: 'post',
                            data: this.dataForm
                        }).then(({data}) => {
                            if (data && data.code === 200) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500
                                })
                                this.visible = false
                                this.$refs['dataForm'].resetFields()
                                this.$emit
                                ('refreshDataList')
                            } else if (data && data.code === 500) {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>
